import { useCallback } from 'react';
import { DEFAULT_DIALOG_EVENT_FILTERS, type DialogEventFilter } from '@/entities/conversations';
import { useSettings } from './useSettings';

/**
 * Отбор событий диалога, запомненный за пользователем. Единственный источник отбора:
 * его читают и лента реплик, и шкала записи — иначе они показывали бы разные события.
 *
 * Отсутствие записи и пустой отбор — разные состояния: пустой список означает снятые
 * пользователем отметки и хранится как есть, иначе снявший все события получал бы
 * умолчание при каждом открытии диалога.
 */
export const useTranscriptEventFilters = () => {
  const { dialogsPage, setDialogsSettings } = useSettings();

  const eventFilters = dialogsPage.transcriptEventFilters ?? DEFAULT_DIALOG_EVENT_FILTERS;

  const setEventFilters = useCallback(
    (filters: DialogEventFilter[]) => setDialogsSettings({ transcriptEventFilters: filters }),
    [setDialogsSettings],
  );

  return { eventFilters, setEventFilters };
};
